import {
  Container,
  ContainerAllocation,
} from "../../../../reducers/componentSearch";
import { SubTitle } from "./InventoryUpdatesStyles";
import {
  FakeLink,
  FlashPCBTable,
  TableCell,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
} from "../../../../constants/Styles";
import ShipmentSummaryDetailFromIds from "../../../ShipmentSummary";
import { useCustomAlert } from "../../../../utils/hooks/alerts";
import useUpdateAllocation from "../../../../utils/hooks/inventory/updateAllocation";
import LoadingOverlay from "../../../LoadingOverlay";
import React, { useState } from "react";
import Modal from "../../../common/Modal";
import ModalContentWithCloseButton from "../../../common/ModalContentWithCloseButton";
import MarkAllocationAsSpent from "../../BoardInventory/MarkAllocationAsSpent";
import { VerticalList } from "../../BoardInventory/BoardInventoryStyles";
import Icon from "../../../common/Icon";

export default function AllocationsSummary({
  container,
  shipmentId,
  onUpdate,
}: {
  container: Container;
  shipmentId?: string;
  onUpdate?: () => void;
}) {
  const [markSpent, setMarkSpent] = useState<boolean>(false);
  const [allocationToSpend, setAllocationToSpend] =
    useState<ContainerAllocation | null>(null);
  const customAlert = useCustomAlert();
  const onErrorRemovingAllocation = (detail: string) => {
    customAlert(detail);
  };
  const onUpdateAllocation = () => {
    onUpdate?.();
  };
  const { updateAllocation, loading } = useUpdateAllocation(
    onUpdateAllocation,
    onErrorRemovingAllocation,
  );

  const removeAllocation = (allocation: ContainerAllocation) => {
    if (container !== null) {
      updateAllocation({
        flashpcb_container_barcode: container.flashpcb_container_barcode,
        board_id: allocation.board_id,
        shipment_id: allocation.shipment_id,
        new_allocated_amount: 0,
        old_allocated_amount: allocation.quantity_allocated,
      });
    }
  };

  const allocationsToDisplay = container.part_allocations.filter(
    (allocation) => {
      return allocation.shipment_id !== shipmentId;
    },
  );

  const markSpentOpen = (allocation: ContainerAllocation) => {
    setMarkSpent(true);
    setAllocationToSpend(allocation);
  };

  const closeModal = () => {
    setMarkSpent(false);
  };

  return allocationsToDisplay.length > 0 ? (
    <div>
      <LoadingOverlay loading={loading} text={"Saving allocation"} />
      <SubTitle>Allocations using this container</SubTitle>
      <FlashPCBTable>
        <thead>
          <TableHeaderRow>
            <TableHeaderCell width={"50%"}>Board</TableHeaderCell>
            <TableHeaderCell>Quantity allocated</TableHeaderCell>
            <TableHeaderCell>Locked</TableHeaderCell>
            <TableHeaderCell>Actions</TableHeaderCell>
          </TableHeaderRow>
        </thead>
        <tbody>
          {allocationsToDisplay.map((allocation) => {
            return (
              <TableRow key={allocation.shipment_id}>
                <TableCell>
                  <ShipmentSummaryDetailFromIds
                    boardId={allocation.board_id}
                    shipmentId={allocation.shipment_id}
                    showBoardOwner={false}
                  />
                </TableCell>
                <TableCell>{allocation.quantity_allocated}</TableCell>
                <TableCell>
                  {allocation.locked ? (
                    <Icon src={"/icons/locked_gray.svg"} alt={"locked"} />
                  ) : null}
                </TableCell>
                <TableCell>
                  <VerticalList>
                    <FakeLink onClick={() => removeAllocation(allocation)}>
                      Remove allocation
                    </FakeLink>
                    <FakeLink onClick={() => markSpentOpen(allocation)}>
                      Spend allocation
                    </FakeLink>
                  </VerticalList>
                </TableCell>
              </TableRow>
            );
          })}
        </tbody>
      </FlashPCBTable>
      {markSpent && allocationToSpend && (
        <Modal isOpen={markSpent} onRequestClose={closeModal}>
          <ModalContentWithCloseButton closeModal={closeModal}>
            <MarkAllocationAsSpent
              container={container}
              quantityAllocatedFromThisContainer={
                allocationToSpend.quantity_allocated
              }
              boardId={allocationToSpend.board_id}
              shipmentId={allocationToSpend.shipment_id}
              closeModal={closeModal}
            />
          </ModalContentWithCloseButton>
        </Modal>
      )}
    </div>
  ) : null;
}
